import { OrderListDefaults, User } from 'src/typings';

export const ORDER_DEFAULT_STATUS_KEYS = ['supply_status', 'procurement_status',
  'fulfillment_status', 'payment_status', 'shipment_status'] as const;

export function emptyOrderDefaults(manager: OrderListDefaults['manager'] = 'me',
  warehouse: OrderListDefaults['warehouse'] = null): OrderListDefaults {
  return { version: 1, manager, warehouse, supply_status: [], procurement_status: [],
    fulfillment_status: [], payment_status: [], shipment_status: [] };
}

export function captureOrderDefaults(form: any, user: User): OrderListDefaults {
  const defaults = emptyOrderDefaults(
    form.user?.id === user.id ? 'me' : form.user?.id ? { id: form.user.id, name: form.user.name } : 'all',
    form.warehouse?.id ? { id: form.warehouse.id, description: form.warehouse.description } : null
  );
  ORDER_DEFAULT_STATUS_KEYS.forEach(key => defaults[key] = [...(form[key] || [])]);
  return defaults;
}

export function orderDefaultFormValue(user?: User, clientContext = false) {
  const defaults = !clientContext && user?.orderListDefaults?.version === 1
    ? user.orderListDefaults : emptyOrderDefaults(clientContext ? 'all' : 'me');
  const statuses: Record<string, string[]> = {};
  ORDER_DEFAULT_STATUS_KEYS.forEach(key => statuses[key] = [...defaults[key]]);
  return { ...statuses, user: defaults.manager === 'me' ? user ?? null :
      defaults.manager === 'all' ? null : { ...defaults.manager },
    warehouse: defaults.warehouse ? { ...defaults.warehouse } : null,
    id: null, client: null, date_from: null, date_to: null };
}
